"use client";

import React from "react";
import { ExternalLink, ArrowRight, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const showcaseItems = [{
  id: 1,
  title: "Dubai Marina Residency",
  category: "Dubai",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/fintech_dashboard_preview.png",
  height: "h-[400px]"
}, {
  id: 2,
  title: "Manhattan Luxury Lofts",
  category: "New York",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/modern_ecommerce_store.png",
  height: "h-[500px]"
}, {
  id: 3,
  title: "Singapore Skygarden",
  category: "Singapore",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/ai_startup_landing_page.png",
  height: "h-[350px]"
}, {
  id: 4,
  title: "London Wharf District",
  category: "London",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/creative_portfolio_dark.png",
  height: "h-[450px]"
}, {
  id: 5,
  title: "Tokyo Smart Precinct",
  category: "Tokyo",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/health_wellness_app.png",
  height: "h-[380px]"
}, {
  id: 6,
  title: "Sydney Harbourside",
  category: "Sydney",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/crypto_exchange_platform.png",
  height: "h-[420px]"
}];
export default function TheAiShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="43715" id="global-project-portfolio" className="dark bg-[#0E0C15] text-white py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#1755FD]/10 rounded-full blur-[120px] pointer-events-none -translate-y-1/2" />
      <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-[#1755FD]/5 rounded-full blur-[100px] pointer-events-none translate-y-1/3" />

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-[42px] font-default font-bold mb-6 tracking-tight">
            Our Global <span className="text-[#1755FD]">Project Portfolio</span>
          </h2>
          <p className="text-lg font-default text-muted-foreground">
            Experience high-quality, interactive digital twins of premier real estate developments 
            across the world's most iconic cities, powered by our spatial intelligence engine.
          </p>
        </div>

        {}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {showcaseItems.map((item, i) => <div key={item.id} data-index={i} className={`break-inside-avoid relative group rounded-[12px] overflow-hidden bg-[#1A1726] border border-[#2D2B35] shadow-lg transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              {}
              <div className="relative overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105" />

                {}
                <div className="absolute inset-0 bg-[#1755FD]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center backdrop-blur-[2px]">
                  <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                    <Button asChild variant="secondary" className="bg-white text-[#0E0C15] hover:bg-white/90 font-default font-semibold rounded-[10px] px-6 shadow-xl">
                      <Link to="#" className="flex items-center gap-2">
                        <Eye className="w-4 h-4" />
                        Explore Project
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>

              {}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-[#0E0C15]/90 via-[#0E0C15]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                <div className="transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-[#1755FD] text-sm font-default font-medium mb-1">
                    {item.category}
                  </p>
                  <h3 className="text-white text-xl font-default font-bold">{item.title}</h3>
                </div>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-[10px] px-8 text-base font-default h-12 bg-[#1755FD] text-white hover:bg-[#1755FD]/90 shadow-lg shadow-[#1755FD]/20">
            <Link to="#">
              View All Projects <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}